var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui container"},[_c('VueSlickCarousel',_vm._b({},'VueSlickCarousel',_vm.settings,false),_vm._l((_vm.banners),function(banner){return _c('div',[_c('img',{staticClass:"ui image",attrs:{"src":banner,"alt":""}})])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }